<template>
<v-app style="background-color:transparent">
    <v-card class="libCard" style="background-color:rgb(77,118,174,0.8) !important">
      <v-card-title class="libTitle">Galerie</v-card-title>
      <v-card-text style="color:#fdfdfd">
        Hier gibts bald Photos =)
        </v-card-text>
    </v-card>
  </v-app>
</template>

<script>
export default {
  name: 'Library'
};
</script>

<style scoped>
.v-card__text, .v-card__title {
  word-break: normal !important;
}
.libCard {
  margin:auto;
  margin-top:10px;
  margin-bottom:10px;
  background-color:rgb(5,5,5,0.7);
  max-width:700px;
}
.libTitle {
  font-size: 1.4em;
  line-height: 1em;
  color: #fdfdfd;
}
</style>